import React, { useState } from 'react';
import s from './ImageSliderBlock.module.css';
import EmbeddedImage from '@/components/Image/Image';
import { ImageSliderBlockProps } from '@/types/components/blocks';

const ImageSliderBlock = ({ data }: ImageSliderBlockProps) => {
    const [start, setStart] = useState(50);

    return (
        <div>
            <div className={`wb-container`}>
                <div className={s.imageSliderBlock__wrapper}>
                    <input
                        type="range"
                        min="0"
                        max="100"
                        value={start}
                        className={s.imageSliderBlock__slider}
                        onChange={(e) => setStart(parseInt(e.target.value))}
                    />
                    <div
                        className={s.imageSliderBlock}
                        style={
                            { '--start': start + '%' } as React.CSSProperties
                        }>
                        <EmbeddedImage imageDetails={data.image1.img} />
                        <EmbeddedImage imageDetails={data.image2.img} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageSliderBlock;
